import { render } from "./radio.vue?vue&type=template&id=2ccbc609&lang=pug"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"
script.render = render

export default script